import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Scale, Download } from "lucide-react";
import { api, money, shortDate } from "../../lib/api";
import { useAuth, apiError } from "../../lib/auth";
import { NeonButton } from "../common";

export const ResolutionPanel = ({ apiKey }) => {
  const { isOwner } = useAuth();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/resolution/cases").then((r) => setD(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const imp = async () => {
    setBusy(true);
    try { const { data } = await api.post("/resolution/import"); toast.success(`Imported ${data.imported} cases, updated ${data.updated}, autopilot acted on ${data.autopilot}`); load(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  if (!d) return null;
  return (
    <section className="panel p-5" data-testid="resolution-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="label-xs flex items-center gap-2"><Scale className="w-3.5 h-3.5 text-brand" /> Whop Resolution Center · <span className="text-brand" data-testid="resolution-open-count">{d.open} need a response</span></p>
        {isOwner && <NeonButton onClick={imp} disabled={busy || !apiKey} data-testid="resolution-import-btn"><Download className="w-3 h-3" /> {busy ? "Importing…" : "Import cases from Whop"}</NeonButton>}
      </div>
      <p className="text-xs text-white/55 mt-2">Customer complaints opened inside Whop (not with the bank). AEGIS attaches verification, consent and access proof, then autopilot denies with evidence, accepts, or stages a reply for you before the deadline.</p>
      <ul className="mt-3 divide-y divide-divider text-sm max-h-72 overflow-y-auto">
        {d.cases.map((c) => (
          <li key={c.id} className="py-2 flex flex-wrap gap-3 items-center" data-testid={`resolution-case-${c.id}`}>
            <span className={`font-mono text-[10px] uppercase w-24 ${c.status === "needs_response" ? "text-amber-300" : c.status === "won" ? "text-brand" : "text-white/45"}`}>{c.status.replace("_", " ")}</span>
            <Link to={`/app/disputes/${c.id}`} className="flex-1 hover:text-brand">{c.customer_name || "Customer"} · {c.raw_reason?.replace(/_/g, " ")}</Link>
            <span className="font-mono">{money(c.amount)}</span>
            <span className="text-xs text-white/45">{c.status === "needs_response" ? `due ${shortDate(c.due_by)}` : shortDate(c.created_at)}</span>
          </li>
        ))}
        {!d.cases.length && <li className="py-2 text-white/45">No cases imported yet.</li>}
      </ul>
    </section>
  );
};
